import React from "react";
import TextInput from "../common/TextInput";
import PasswordInput from "../common/PasswordInput";
import SubmitButton from "../common/SubmitButton";

type LoginFormProps = {
  passwordChange: any;
  username: string;
  password: string;
  usernameChange: any;
  onLogin: any;
  errors: any;
  submitting: boolean;
};

const LoginForm = ({
  passwordChange,
  username,
  password,
  usernameChange,
  onLogin,
  errors,
  submitting,
}: LoginFormProps) => {
  return (
    <div className="bg-dustyGray-300 dark:bg-shipGray-400 shadow-md w-5/6 lg:w-2/5 rounded px-8 pt-6 pb-8 mt-24 mx-auto flex flex-col justify-center min-w-min transition duration-300">
      {errors.username && (
        <div className="alert alert-danger">{errors.username}</div>
      )}
      {errors.password && (
        <div className="alert alert-danger">{errors.password}</div>
      )}
      {errors.onLogin && (
        <div className="alert alert-danger">{errors.onLogin}</div>
      )}
      <form onSubmit={onLogin} className="z-10 rounded text-center">
        <div className="break-none">
          <div className="flex flex-col md:flex-row items-center">
            <h2 className="mx-3 text-2xl transition duration-300">
              Sign in to WildXR
            </h2>
          </div>
          <TextInput
            name={"Email"}
            label={"Username"}
            className=""
            value={username}
            type="text"
            placeholder="Username"
            onChange={usernameChange}
            initialFocus={true}
            disabled={false}
            error={""}
          />

          <PasswordInput
            name={"Password"}
            label={"Password"}
            value={password}
            error={{}}
            className="form-control rounded px-2 py-2 border-0 text-charcoal-900 dark:text-dustyGray-300 bg-dustyGray-100 dark:bg-dustyGray-700 transition duration-300"
            placeholder="Password"
            onChange={passwordChange}
          />
        </div>
        <div className="flex items-end">
          {/* <a
                        className="mr-2 inline-block align-baseline font-bold text-sm text-dustyGray-900 dark:text-dustyGray-300 hover:text-darkElectricBlue-700 italic transition duration-300"
                        href="/forgotPassword"
                    >
                        Forgot Password?
                    </a> */}
          <SubmitButton
            submitting={submitting}
            name="Log In"
            submittingName="Logging In..."
            onClick={onLogin}
            className="details-save text-dustyGray-700 hover:bg-harvestGold-600 hover:text-white rounded transition duration-300 bg-harvestGold-500 py-1 px-3 ml-2 text-white focus:outline-none focus:ring focus:ring-charcoal-300"
          />
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
